import {
    ACTIVATE_PROCESS_INIT,
    ACTIVATE_PROCESS_DONE,
    ACTIVATE_PROCESS_ERROR,
    ACTIVATE_PROCESS_PROCESSING,
    ACTIVATE_PROCESS_NOT_PROCESSING,
} from "../action-types/activateProjectProcess"

const initProcessing = {
    processedTask: 0,
    processStatus: "not start",
    totalNumber: 0,
    processMessage: "",
    processResults: [],
    processError: false,
}
export default function activateProjectProcessReducer(state = initProcessing, action) {
    switch (action.type) {
        case ACTIVATE_PROCESS_INIT:
            return {
                processedTask: 0,
                processStatus: "processing",
                totalNumber: action.payload,
                processMessage: "",
                processResults: [],
                processError: false,
            }
        case ACTIVATE_PROCESS_PROCESSING:
            return {
                ...state,
                processedTask: action.payload.processedTask,
                processStatus: "processing",
                processMessage: action.payload.processMessage,
            }
        case ACTIVATE_PROCESS_DONE:
            return {
                ...state,
                processedTask: action.payload.processedTask,
                processStatus: "done",
                processMessage: "Processing Finish",
                processResults: action.payload.results,
            }
        case ACTIVATE_PROCESS_ERROR:
            return {
                ...state,
                processStatus: "error",
                processMessage: "Processing Error",
                processResults: [],
                processError: true,
            }
        case ACTIVATE_PROCESS_NOT_PROCESSING:
            return initProcessing
        default:
            return state
    }
}
